import { cloneDeep, get } from 'lodash';
export const EnumClauseTypes = {
  DYNAMIC: 1,
  STATIC: 2,
  WHOLE: 3,
  OTHER: 4
}

/**
 * 处理责任数据
 * @param allClauseList 接口返回的所有责任列表
 * @param type 0-订单维度责任 1-计划维度责任
 */
export function processClauses(allClauseList, type) {
  return allClauseList
    .filter((clause) => clause.type === type)
    .map((clause) => {
      if (clause && !clause.selected && get(clause, 'optionList.length')) {
        if (clause.selected) {
          // 可展示列表（disabled=false）优先取默认值（isDefault=1），没有则取第一个
          let ableOptionList = clause.optionList.filter((o) => !o.disabled);
          if (ableOptionList.length > 0) {
            let defaultOptionList = ableOptionList.filter((o) => o.isDefault === 1);
            if (defaultOptionList.length > 0) {
              clause.selected = defaultOptionList[0];
            } else {
              clause.selected = ableOptionList[0];
            }
          }
          // console.log('clause.selected', clause.selected);
        }
      } else {
        // console.log('现在是服务端返回更新数据');
      }
      return clause;
    })
    .sort((a, b) => a.sort - b.sort);
}

/**
 * 设置保障责任配置错误
 * @param allClauseList
 */
export function setClausesErrMsg(allClauseList, toast) {
  // console.log('💠 设置保障责任配置错误', allClauseList);
  for (let i = 0; i < allClauseList.length; i++) {
    const clause = allClauseList[i];
    if (clause.errorMessages) {
      toast && toast(clause.errorMessages[0]);
      return;
    }
  }
}

// 算费之后更新每个职业中的 perPrice 和 premium
export const updateProfessionsByJobs = (professions, jobs) => {
  if (!jobs) {
    return professions
  }
  const cloneProfessions = cloneDeep(professions)
  cloneProfessions.forEach(profession => {
    const matchedJob = jobs.find(j => j.jobCode + '' == profession.code + '')
    if (matchedJob) {
      profession.perPrice = matchedJob.perPrice
      profession.premium = matchedJob.premium
    }
  })
  return cloneProfessions
};

// 算费之后更新每个计划中的PlanClauseList，主要是塞入premiumMap
export const updatePlanClauseList = (oldPlanClauseList, newClauses) => {
  for(let i = 0; i < oldPlanClauseList.length; i++) {
    const clause = oldPlanClauseList[i]
    const matchedClause = newClauses.find(c => c.clauseCode + '' == clause.clauseCode + '')
    if (matchedClause) {
      clause.premiumMap = matchedClause.premiumMap
    }
  }
  return oldPlanClauseList
};

// 报价页：算费之后更新每个职业中的 perPrice 和 premium
export const updateProfessionsByJobsQuote = (professionList, jobs) => {
  if (!jobs) {
    return professionList
  }
  const cloneProfessionList = cloneDeep(professionList)
  cloneProfessionList.forEach(profession => {
    // 职业细类
    const professionJobCode = get(profession, 'professions.code')
    // 职业大类
    const professionJobType = get(profession, 'professions.val')
    let matchedJob
    // 因为报价页有时候只需要选择职业大类，所以没有 jobCode，所以只要匹配职业大类相同
    if (professionJobCode) {
      matchedJob = jobs.find(j => j.jobCode + '' == professionJobCode + '')
    } else if (professionJobType) {
      matchedJob = jobs.find(j => j.jobType + '' == professionJobType + '')
    }
    if (matchedJob) {
      profession.perPrice = matchedJob.perPrice
      profession.premium = matchedJob.premium
    }
  })
  return cloneProfessionList
};


// WEBPACK FOOTER //
// ./src/util/clause.js